// window?.addEventListener('beforeunload', () => {
//   const isMacIOS = document?.documentElement?.classList?.contains('ios');

//   if (!isMacIOS) {
//     return null;
//   }

//   sessionStorage?.setItem('scrollPosition', window?.scrollY);
// });

// window?.addEventListener('DOMContentLoaded', () => {
//   const isMacIOS = document?.documentElement?.classList?.contains('ios');
//   const scrollPosition = sessionStorage?.getItem('scrollPosition');

//   if (!isMacIOS) {
//     return null;
//   }

//   if (scrollPosition) {
//     window?.scrollTo(0, parseInt(scrollPosition, 10));
//   }
// });

document?.addEventListener('DOMContentLoaded', function () {
  const isMacIOS = document?.documentElement?.classList?.contains('ios');

  if (!isMacIOS) {
    return null;
  }

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // Restore scroll position on back navigation
  window.addEventListener('popstate', function () {
    const scrollY = sessionStorage.getItem('scroll-position') || 0;
    window.scrollTo(0, parseInt(scrollY, 10));
  });

  // Save scroll position before navigating away
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a');
    if (
      link &&
      link.href &&
      link.target !== '_blank' &&
      !link.href.includes('#')
    ) {
      sessionStorage.setItem('scroll-position', window.scrollY);
    }
  });
});
